import { render, staticRenderFns } from "./onPageSizeChange-editor.vue?vue&type=template&id=d8a81f60&scoped=true&"
import script from "./onPageSizeChange-editor.vue?vue&type=script&lang=js&"
export * from "./onPageSizeChange-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a81f60",
  null
  
)

export default component.exports